// extracted by mini-css-extract-plugin
module.exports = {"root":"stacked-images_root__h6u0R"};